import React from 'react';
import CookieConsent from '~/components/CookieConsent';
import Footer from '~/components/layout/Footer';
import Header from '~/components/layout/Header';
import Container from '~/components/ui/Container';

interface ImageLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  breadcrumbs?: React.ReactNode;
  image?: string;
}

const ImageLayout = ({ breadcrumbs, image, children }: ImageLayoutProps) => {
  return (
    <div className="relative flex min-h-dvh flex-col">
      <Header />
      <main className="flex-grow">
        <div className="relative mb-20 h-[clamp(320px,30vw,720px)]">
          {!!breadcrumbs && (
            <Container className="relative z-10 py-4 md:py-8">
              {breadcrumbs}
            </Container>
          )}
          <div
            className="absolute -top-full bottom-0 w-full -skew-y-2 overflow-hidden bg-gradient-to-b from-blue-900 from-80% to-white to-90% contain-paint"
            style={{ boxShadow: 'inset 0 -1px 0 0 rgb(255, 255, 255)' }}
          >
            {image && (
              <>
                <div
                  className="absolute -bottom-8 left-0 top-1/2 z-10 w-full skew-y-2 bg-cover bg-center opacity-50"
                  style={{
                    backgroundImage: `url('${image}')`,
                    boxShadow: 'inset 0 -1px 0 0 rgb(255, 255, 255)',
                  }}
                />
                <div className="absolute -bottom-8 left-0 top-1/2 z-20 w-full bg-gradient-to-b from-sand-50/0 from-40% to-sand-50/100 to-75%" />
                <div className="absolute bottom-0 left-0 z-30 h-px w-full bg-white" />
              </>
            )}
          </div>
        </div>
        {children}
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default ImageLayout;
